﻿import * as React from "react";

export interface IFileDisplayProps {
    fileName: string;
}

export const FileDisplay: React.FunctionComponent<IFileDisplayProps> = (
    props,
): React.ReactElement => (
    <div className={`fileelement`}>
        <img src={`/Images/UI/UploadIconGreen.svg`} />
        <div className={`fileelement-properties`}>
            <div className={`fileelement-name`}>{props.fileName}</div>
        </div>
    </div>
);
